import type { VarianteDeSku } from '../lib/variantes';
import { formatoStock } from './StockSku';

/** Elige una variante de un SKU: «Sin asignar» (null) primero y por defecto, y después una por variante con su recuadro de color. */
export function ChipsVariante({ etiqueta, variantes, valor, onChange, sinAsignar, conSinAsignar = true }: {
  etiqueta: string; variantes: Array<Pick<VarianteDeSku, 'id' | 'nombre' | 'colorHex' | 'cantidad'>>; valor: number | null; onChange: (id: number | null) => void;
  /** false: sin la opción «Sin asignar» (hay que elegir un color). */
  conSinAsignar?: boolean;
  /** Si viene, cada chip muestra su cantidad (la de Sin asignar es este número). */
  sinAsignar?: number;
}) {
  const cantidad = (id: number | null, c: number) => (sinAsignar === undefined ? '' : ` · ${formatoStock(id === null ? sinAsignar : c)}`);
  const opciones: Array<{ id: number | null; nombre: string; colorHex: string | null; cantidad: number }> = [
    ...(conSinAsignar ? [{ id: null, nombre: 'Sin asignar', colorHex: null, cantidad: 0 }] : []),
    ...variantes,
  ];
  return (
    <div role="radiogroup" aria-label={etiqueta} className="flex flex-wrap gap-2">
      {opciones.map((o) => (
        <button key={o.id ?? 'sin-asignar'} type="button" role="radio" aria-checked={valor === o.id} onClick={() => onChange(o.id)}
          className={`inline-flex items-center gap-1.5 px-3 py-1 text-sm rounded-full border ${valor === o.id ? 'border-brand-500 bg-brand-50 text-brand-700' : 'border-slate-300 text-slate-600 hover:bg-slate-50'}`}>
          {o.id !== null && <span aria-hidden className="inline-block w-3 h-3 rounded border border-slate-300" style={{ backgroundColor: o.colorHex ?? 'transparent' }} />}
          {o.nombre}{cantidad(o.id, o.cantidad)}
        </button>
      ))}
    </div>
  );
}
